import { CssBaseline, ThemeProvider as MuiThemeProvider } from '@mui/material';
import type { PropsWithChildren } from 'react';

import { appTheme } from './theme';

export function ThemeProvider({ children }: PropsWithChildren) {
  return (
    <MuiThemeProvider
      defaultMode="light"
      disableTransitionOnChange
      modeStorageKey="aurora-mode"
      theme={appTheme}
    >
      <CssBaseline enableColorScheme />
      {children}
    </MuiThemeProvider>
  );
}
